import seo from '../assets/certificates/seo.png';
import g4a from '../assets/certificates/g4a.png';
import po from '../assets/certificates/po.svg';
import ux from '../assets/certificates/ux.png';


const certificates = [
    {
        id: 1,
        image: seo,
        subtitleKey: 'certificates.seoII.title',
        date: 'certificates.seoII.date',
        provider: 'certificates.seoII.provider',
        link: 'https://app.hubspot.com/academy/achievements/p3g4g9lg/en/1/eduardo-silva/seo-ii'
    },
    {
        id: 2,
        image: g4a,
        subtitleKey: 'certificates.g4a.title',
        date: 'certificates.g4a.date',
        provider: 'certificates.g4a.provider',
        link: 'https://skillshop.credential.net/034e97e1-e0ed-49e7-bc1f-82c699ca2916'
    },
    {
        id: 3,
        image: po,
        subtitleKey: 'certificates.po.title',
        date: 'certificates.po.date',
        provider: 'certificates.po.provider',
        link: 'https://www.scrum.org/certificates/1185451'
    }, {
        id: 4,
        image: seo,
        subtitleKey: 'certificates.seo.title',
        date: 'certificates.seo.date',
        provider: 'certificates.seo.provider',
        link: 'https://app.hubspot.com/academy/achievements/268wftmg/en/1/eduardo-silva/seo'
    },
    {
        id: 5,
        image: ux,
        subtitleKey: 'certificates.ux.title',
        date: 'certificates.ux.date',
        provider: 'certificates.ux.provider',
        link: 'https://coursera.org/share/8036b58ffe5d35c3616ead8a7e81110a'
    }
];


export default certificates;